module.exports = __webpack_public_path__ + "static/media/aboutUs_18.a3bb4201.jpg";